import { useCallback } from 'react';

export function useSnapPosition(snapSize) {
  return useCallback((val) => {
    if (!snapSize || snapSize <= 0) return val;
    return Math.round(val / snapSize) * snapSize;
  }, [snapSize]);
}

export function useAlignmentGuides(elements, activeId, threshold = 5) {
  return useCallback((x, y, w, h) => {
    if (!elements || !activeId) return { x: null, y: null, snapX: x, snapY: y };

    let guideX = null, guideY = null;
    let snapX = x, snapY = y;

    for (const el of elements) {
      if (el.id === activeId) continue;
      const fp = el.freePosition || {};
      if (!fp.x && fp.x !== 0) continue;

      if (Math.abs(x - fp.x) < threshold) { guideX = fp.x; snapX = fp.x; }
      if (Math.abs(x + w - (fp.x + (fp.w || 0))) < threshold) { guideX = fp.x + (fp.w || 0); snapX = guideX - w; }
      if (Math.abs((x + w / 2) - (fp.x + (fp.w || 0) / 2)) < threshold) { guideX = fp.x + (fp.w || 0) / 2; snapX = guideX - w / 2; }

      if (Math.abs(y - fp.y) < threshold) { guideY = fp.y; snapY = fp.y; }
      if (Math.abs(y + h - (fp.y + (fp.h || 0))) < threshold) { guideY = fp.y + (fp.h || 0); snapY = guideY - h; }
      if (Math.abs((y + h / 2) - (fp.y + (fp.h || 0) / 2)) < threshold) { guideY = fp.y + (fp.h || 0) / 2; snapY = guideY - h / 2; }
    }

    return { x: guideX, y: guideY, snapX, snapY };
  }, [elements, activeId, threshold]);
}

export function calculatePageForPosition(y, pageHeight, headerHeight, footerHeight, bodyHeight) {
  const usableHeight = bodyHeight;
  if (y < usableHeight) return 0;
  return Math.floor(y / usableHeight);
}

export function distributeElementsToPages(elements, pageBodyHeight, gap = 10) {
  const pages = [[]];
  let currentPageIndex = 0;
  let currentY = 0;

  const sorted = [...elements].sort((a, b) => (a.freePosition?.y || 0) - (b.freePosition?.y || 0));

  for (const element of sorted) {
    const elHeight = element.freePosition?.h || 100;
    if (currentY + elHeight > pageBodyHeight && pages[currentPageIndex].length > 0) {
      currentPageIndex++;
      pages[currentPageIndex] = [];
      currentY = 0;
    }
    pages[currentPageIndex].push({
      ...element,
      _pageIndex: currentPageIndex,
      _pageY: currentY,
    });
    currentY += elHeight + gap;
  }

  return pages;
}
